import { ActiveCart } from 'types/cart';

export const isLongTermPreOrder = (cart: ActiveCart) => {
  if (
    !cart?.longTermPreOrder?.hasLongTermPreOrderItem ||
    !cart?.longTermPreOrder?.longTermPreOrderItemPaymentMethods
  )
    return false;

  return cart?.longTermPreOrder?.hasLongTermPreOrderItem;
};

export const isLongTermPreOrderPaymentMethod = (
  cart: ActiveCart,
  paymentMethod: string
) => {
  if (!isLongTermPreOrder(cart)) return false;

  const longTermPreOrderItemPaymentMethods = (
    cart?.longTermPreOrder?.longTermPreOrderItemPaymentMethods as string
  ).split(',');
  return longTermPreOrderItemPaymentMethods.indexOf(paymentMethod) > -1;
};
